// Single source of truth for job status colours — used by the FullCalendar
// events, the leaflet map markers, and consistent with the status pill
// palette in App.css (.calendar-job.scheduled/in_progress/completed).
//
// Pass 6 adds two client-driven statuses:
//   requested            — client "Request a job" (blue; sits in the
//                          requests strip until staff schedule it)
//   reschedule_requested — client asked to move a scheduled visit
//                          (amber; dashed border + badge on the calendar,
//                          cleared when staff confirm a new slot)

export const STATUS_COLORS = {
  scheduled: { bg: '#e7f0eb', border: '#173e36', text: '#1d4438' },
  in_progress: { bg: '#fff4d6', border: '#8a6d1a', text: '#8a6d1a' },
  completed: { bg: '#e3efe6', border: '#2c6b46', text: '#2c6b46' },
  requested: { bg: '#dbeafe', border: '#1d4ed8', text: '#1e40af' },
  reschedule_requested: { bg: '#fdf1dc', border: '#b7791f', text: '#8a5a12' },
};

export function statusColor(status) {
  return STATUS_COLORS[status] || STATUS_COLORS.scheduled;
}
